<template>
    <div class="section-content bg-white text-gray-700 text-center py-8">
        <div class="text-lg max-w-2xl mx-auto" v-html="sectionContent" />
    </div>
</template>

<script>

export default {
  props: {
    sectionContent: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.section-content a {
    @apply text-gold-500 underline
}
</style>
